import * as React from 'react';
import { UIHeading1, UIHeading5, Spinner } from '@cian/ui-kit';
import { IHistoryState } from '../../store/filters/actions';
import { getVillageListSeoText, isArrayWithItems } from '../../utils';
import { AdFoxBannerContainer } from '../adfox/container';
import { BreadcrumbsContainer } from '../../containers/BreadcrumbsContainer';
import { FeedbackContainer } from '../feedback/container';
import { FiltersContainer } from '../filters/container';
import { NotFoundContainer } from '../../containers/NotFoundContainer';
import { PaginationContainer } from '../pagination/container';
import { SortingContainer } from '../../containers/SortingContainer';
import { IVillageListPageProps } from '../../containers/VillageListPage';
import { VillageListItemContainer } from '../../containers/VillageListItem';
import * as styles from './VillageListPage.css';
import { SeoMarkedListContainer } from '../../containers/SeoMarkedListContainer';
import { BlackFridayBannerContainer } from '../../containers/BlackFridayBannerContainer';

export const VillageListPage = (props: IVillageListPageProps) => {
  const {
    filters,
    isFetching,
    regionHasRoads,
    villageList,
    pageHeading,
    regionHasStations,
    seoData,
    refreshPage,
    totalItems,
  } = props;
  const isNotEmpty = isArrayWithItems(villageList);
  const seoText = getVillageListSeoText(!isNotEmpty, seoData);

  React.useEffect(() => {
    const refreshPageHandler = ({ state }: { state: IHistoryState }) => {
      if (state && state.filters) {
        refreshPage(state.filters);
      }
    };

    window.addEventListener('popstate', refreshPageHandler, false);

    return () => {
      window.removeEventListener('popstate', refreshPageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles['village_list_page']}>
      {isFetching && (
        <div className={styles['preload_overlay']}>
          <div className={styles['preloader']}>
            <Spinner />
          </div>
        </div>
      )}
      <FiltersContainer />
      <div className={styles['village_list']}>
        <div className={styles['village_list-top']}>
          <BreadcrumbsContainer />
        </div>
        <div className={styles['village_list-heading']}>
          <UIHeading1 as="h1">{pageHeading}</UIHeading1>
        </div>
        <BlackFridayBannerContainer />
        {isNotEmpty ? (
          <>
            <div className={styles['summary']}>
              <UIHeading5>{totalItems}</UIHeading5>
              <SortingContainer />
              <div className={styles['feedback']}>
                <FeedbackContainer />
              </div>
            </div>
            <div>
              {villageList.map(village => (
                <VillageListItemContainer
                  key={village.id}
                  filters={filters}
                  regionHasRoads={regionHasRoads}
                  regionHasStations={regionHasStations}
                  village={village}
                  serpLink={props.serpLink}
                />
              ))}
            </div>
          </>
        ) : (
          <NotFoundContainer />
        )}
        <PaginationContainer />
        <div className={styles['banners']}>
          <AdFoxBannerContainer key="BANNER_1" className={styles['banner']} placement="footer" />
          <AdFoxBannerContainer key="BANNER_2" className={styles['banner']} placement="footer" />
          <AdFoxBannerContainer key="BANNER_3" className={styles['banner']} placement="footer" />
        </div>
        <SeoMarkedListContainer />
        {seoText && <div className={styles['seo_text']}>{seoText}</div>}
      </div>
    </div>
  );
};
